define(["require", "exports", "./AnalyticsStore", "./ConfigStore", "./EntityStore", "./MapStore", "./ModalStore", "./NotificationStore", "./RouteStore", "./SearchStore", "./UIStore", "./UserStore"], function (require, exports, AnalyticsStore_1, ConfigStore_1, EntityStore_1, MapStore_1, ModalStore_1, NotificationStore_1, RouteStore_1, SearchStore_1, UIStore_1, UserStore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StoreManager = exports.injectStores = void 0;
    function injectStores(context) {
        return {
            configStore: context.stores.configStore,
            modalStore: context.stores.modalStore,
            notificationStore: context.stores.notificationStore,
            mapStore: context.stores.mapStore,
            uiStore: context.stores.uiStore,
            entityStore: context.stores.entityStore,
            searchStore: context.stores.searchStore,
            analyticsStore: context.stores.analyticsStore,
            routeStore: context.stores.routeStore,
            userStore: context.stores.userStore
        };
    }
    exports.injectStores = injectStores;
    ;
    class StoreManager {
        get Stores() {
            return {
                configStore: this.configStore,
                modalStore: this.modalStore,
                notificationStore: this.notificationStore,
                entityStore: this.entityStore,
                uiStore: this.uiStore,
                searchStore: this.searchStore,
                analyticsStore: this.analyticsStore,
                mapStore: this.mapStore,
                routeStore: this.routeStore,
                userStore: this.userStore
            };
        }
        constructor() {
            Object.defineProperty(this, "configStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "modalStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "notificationStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "entityStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "uiStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "searchStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "analyticsStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "mapStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "routeStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "userStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.modalStore = new ModalStore_1.ModalStore(this);
            this.notificationStore = new NotificationStore_1.NotificationStore(this);
            this.uiStore = new UIStore_1.UIStore(this);
            this.mapStore = new MapStore_1.MapStore(this);
            this.searchStore = new SearchStore_1.SearchStore(this);
            this.analyticsStore = new AnalyticsStore_1.AnalyticsStore(this);
            this.configStore = new ConfigStore_1.ConfigStore(this);
            this.entityStore = new EntityStore_1.EntityStore(this);
            this.routeStore = new RouteStore_1.RouteStore(this);
            this.userStore = new UserStore_1.UserStore(this);
        }
        static get Instance() {
            if (!StoreManager.instance) {
                StoreManager.instance = new StoreManager();
            }
            return StoreManager.instance;
        }
    }
    exports.StoreManager = StoreManager;
});
